import React, { FunctionComponent } from "react";

export const Message: FunctionComponent = ({ children }) => (
    <h2 style={{ margin: "auto", color: "#FAFAFA" }}>
        {children}
    </h2>
);
